import CustomPage from "../../components/CustomPage";
import * as React from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import ServicesCall from "./servicesCall";
import NullCheck from "../../components/NullCheck";
import { PLUGIN_NAME } from "../../config/const";
import McMonitoring from "./mcMonitoring";
import MeterRead from "./meterRead";
import { useSelector } from "react-redux";
import System from "./system";
import CheckRole from "components/CheckRole";
import { ADMIN } from "config/roles";

const Dashboard = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const biz = useSelector((state) => state?.biz?.data);
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);

  return (
    <CustomPage hidePadding>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent={{ xs: "center", md: "start" }}
        alignItems={{ xs: "center", md: "start" }}
        gap={5}
        padding={2}
      >
        {/* <NullCheck valueForCheck={biz?.isSystem}> */}
        <CheckRole role={ADMIN}>
          <NullCheck valueForCheck={selectedPlugin === PLUGIN_NAME.SYSTEM}>
            <System />
          </NullCheck>
        </CheckRole>
        {/* </NullCheck> */}

        <NullCheck valueForCheck={selectedPlugin === PLUGIN_NAME.SERVICES_CALL}>
          <ServicesCall />
        </NullCheck>

        <NullCheck valueForCheck={selectedPlugin === PLUGIN_NAME.MICRO_CONTROLLERS}>
          <McMonitoring isMobile={isMobile} />
        </NullCheck>

        <NullCheck valueForCheck={selectedPlugin === PLUGIN_NAME.METER_READ}>
          <MeterRead />
        </NullCheck>
      </Stack>
    </CustomPage>
  );
};
export default Dashboard;
